const availableDaysQuestion = {
  name: 'availableDays',
  title: "Which days are you available to work out?",
  description: 'Select at least 2. Don’t worry, you can update this later.',
  type: 'checkbox',
  choices: [
    {
      value: "Monday",
      text: 'Monday',
    },
    {
      value: "Tuesday",
      text: 'Tuesday',
    },
    {
      value: "Wednesday",
      text: 'Wednesday',
    },
    {
      value: "Thursday",
      text: 'Thursday',
    },
    {
      value: "Friday",
      text: 'Friday',
    },
    {
      value: "Saturday",
      text: 'Saturday',
    },
    {
      value: "Sunday",
      text: 'Sunday',
    },
  ],
  minSelectedChoices: 3,
  isRequired: true,
  validateMinSelectedChoices: true,
  validators: [{
    "type": "expression",
    "text": "Select at least 2",
    "expression": "{availableDays.length} > 1"
  }]
};

export {
  availableDaysQuestion,
}
